// react library imports
import { useRef } from "react";

// import from utils
import { useClickOutside } from "Utils/common";

// style import 
import 'style/dropDown.css';

const DropDown = ({children, close}) => {
    // define dispatch action
    const boxRef = useRef()
    // Close box when clicking outside
    useClickOutside(boxRef, ()=>close(false));
  return (
    <div className='drop_down_container mues_column_flex' ref={boxRef}>
        {children}
    </div>
  )
}

export default DropDown